import React, {useEffect} from 'react'
import {Helmet} from "react-helmet";

import ImgBee from '../images/step-one-bee.jpg'
import ImgHive from '../images/bb-hivebox-callouts.svg'

const StepOne = ({multipleLoc, packData}) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])
    return (
        <div className="step step-one step-wrapper">
        <Helmet>
            <meta charSet="utf-8" />
            <title>Hive Locations || Busy Bee Honey</title>
        </Helmet>
            <div className="contain">
                <section>
                    <h1>Bees made this honey in:</h1>
                    {multipleLoc &&
                        <p className="span-block">
                            {packData.hiveLocations.map((loc, i) => {
                                return(
                                    <span key={i}><strong>{loc}</strong></span>
                                )
                            })}    
                        </p>  
                    } 
                    {!multipleLoc && 
                        <p className="span-block"><span><strong>{packData.hiveLocation}</strong></span></p>
                    }
                    <p><strong>Crop Year:</strong><span className="pad-left">{packData.cropYear}</span></p>
                    <p><span><strong>Primary Floral Sources:</strong><span className="pad-left"></span>{packData.floral}</span></p>
                    <div className="img-wrapper">
                        <img id="step-one-bee" src={ImgBee} alt="illustration bee and flower" />
                    </div>
                    <p>Busy Bee Raw Honey is made naturally by bees from the flower nectar they gather. The primary floral sources listed above represent some of the flowers the bees used to make the honey. This information is sourced through third-party lab analysis of the pollens found in the honey.
                    </p>
                </section>
                <section>
                    <h2>Parts of the hive:</h2>
                    <div className="img-wrapper">
                        <img src = {ImgHive} alt="exploded view of bee hive" />
                    </div>
                    <div className="hive-break-down">
                        <h3>1. Landing board</h3>
                        <span className="desc">Helps bees get in and out of the hive easily</span>
                        <h3>2. Brood nest where the queen lives</h3>
                        <span className="desc">Worker bees tend to new members of the hive</span>
                        <h3>3. Boxes where bees store honey</h3>
                        <span className="desc">There can be 2-3 honey boxes per hive</span>
                        <h3>4. Outer and inner covers</h3>
                        <span className="desc">Allows fresh air to circulate through the hive</span>
                    </div>
                </section>          
            </div>
        </div>
    )
}

export default StepOne
